<script>
    import { section } from "../store/section.js";
    import { token } from "../store/token.js";
    import { active_workspace } from "../store/workspace.js";

    import { fetch_workspace_member_list } from "../api/request.js";
    import HeadingContent from "./component/HeadingContent.svelte";

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    const remove_member = (member) => {
        confirm(`Do you really want to remove ${member.user.email}?`);
    };
</script>

<div class="settings-holder settings-active">
    <!-- Settings Connections Overview (First Level) (the items of the menu of Security)-->
    <div class="settings-holder-content content-active">
        <HeadingContent
            title="{$active_workspace.title}"
            back_button_enabled={true}
            back_button_click_action={() => {
                set_section("account/workspaces/overview");
            }}
        />
        <!--
        <div class="settings-heading">
            <div
                class="heading-block"
                on:click={() => {
                    set_section("account/workspaces/overview");
                }}
            >
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title"
                            >{$active_workspace.title}</strong
                        >
                    </div></a
                >
            </div>
        </div>
        -->
        {#await fetch_workspace_member_list($active_workspace.string_id, $token)}
            <div class="settings-content">
                <div class="settings-content-holder">
                    <div class="card-h-100">
                        <div class="content-block">
                            <h3 class="title-card-block text-white">
                                Loading Member List
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        {:then member_list}
            <div class="settings-content">
                <div class="settings-content-holder">
                    <div class="card-h-100">
                        <div class="content-block">
                            <h3 class="title-card-block text-white">
                                Member List
                            </h3>
                            <div
                                class="card-settings-main card bg-transparent-mobile"
                            >
                                <div class="card-body">
                                    <nav>
                                        <ul
                                            class="nav-second-level nav-settings"
                                        >
                                            {#each member_list as member}
                                                <li>
                                                    <div
                                                        class="opener-third-level"
                                                    >
                                                        <div
                                                            class="df-row df-aic gx-2"
                                                        >
                                                            <div
                                                                class="col-auto"
                                                            >
                                                                <span
                                                                    class="ico-holder has-bg"
                                                                >
                                                                    {#if member.user.avatar_url}
                                                                        <img
                                                                            src={member
                                                                                .user
                                                                                .avatar_url}
                                                                            alt=""
                                                                            loading="lazy"
                                                                            width="15"
                                                                            height="15"
                                                                        />
                                                                    {:else}
                                                                        <img
                                                                            src="https://dvr722unfp578.cloudfront.net/image/workspace_image/c5bca08aed57d9d634b8e1541cb0140a44a64d213eb8acd183ef1249272daa53.jpg"
                                                                            loading="lazy"
                                                                            alt=""
                                                                            width="15"
                                                                            height="15"
                                                                        />
                                                                    {/if}
                                                                </span>
                                                            </div>
                                                            <div class="col">
                                                                <div
                                                                    class="opener-text"
                                                                >
                                                                    <div
                                                                        class="df-row df-jcb df-aic"
                                                                    >
                                                                        <div
                                                                            class="col"
                                                                        >
                                                                            <strong
                                                                                class="nav-title"
                                                                                >{member
                                                                                    .user
                                                                                    .email}</strong
                                                                            >
                                                                            <div
                                                                                class="nav-text"
                                                                            >
                                                                                <p
                                                                                >
                                                                                    {member.workspace_role}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            class="col-auto"
                                                                        >
                                                                            <a
                                                                                class="btn btn-danger"
                                                                                href="#"
                                                                                on:click={() => {
                                                                                    remove_member(
                                                                                        member
                                                                                    );
                                                                                }}
                                                                                >Remove</a
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            {/each}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/await}
    </div>
</div>
